/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface InstitutionSearchDto
 */
export interface InstitutionSearchDto {
    /**
     * 
     * @type {TextSearch}
     * @memberof InstitutionSearchDto
     */
    denomination?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof InstitutionSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof InstitutionSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof InstitutionSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InstitutionSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof InstitutionSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the InstitutionSearchDto interface.
 */
export function instanceOfInstitutionSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionSearchDtoFromJSON(json: any): InstitutionSearchDto {
    return InstitutionSearchDtoFromJSONTyped(json, false);
}

export function InstitutionSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'denomination': !exists(json, 'denomination') ? undefined : TextSearchFromJSON(json['denomination']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function InstitutionSearchDtoToJSON(value?: InstitutionSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'denomination': TextSearchToJSON(value.denomination),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

